import { filter } from 'lodash';
import { useState, useEffect, useCallback, useMemo } from 'react';
import {
  Box,
  Card,
  Table,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Typography,
  TableContainer,
  TablePagination,
  Divider
} from '@mui/material';
import { useNavigate, Link } from 'react-router';

// redux
// utils
import { addOneDay, fDateTime } from '../../../../utils/formatTime';
import { fCurrency } from '../../../../utils/formatNumber';
import { ProductListHead, ProductListToolbar } from '../../e-commerce/product-list';
import Scrollbar from '../../../Scrollbar';
import SearchNotFound from '../../../SearchNotFound';
import { firestore } from '../../../../contexts/FirebaseContext';
import { MenuButton } from '../../../atomos/MenuButton';
import useFilter from '../../../../hooks/useFilter';
import useAuthUsers from '../../../../hooks/useAuthUsers';

// const TABLE_HEAD = [
//   // { id: 'id', label: '#', alignRight: false },
//   { id: 'name', label: 'Propietario', alignRight: false },
//   { id: 'orden', label: 'Usuario asignado', alignRight: false },
//   { id: 'created_at', label: 'Fecha', alignRight: false },
//   { id: 'cantidad', label: 'Productos', alignRight: false },
//   { id: 'totalAmount', label: 'Precio', alignRight: false },
//   { id: 'costo', label: 'Costo', alignRight: false },
//   { id: 'utilida', label: 'U. Total', alignRight: false },
//   { id: 'ulic', label: 'U. Licenciatario', alignRight: false },
//   { id: 'udag', label: 'U. Dagpacket', alignRight: false },
//   { id: 'status', label: 'Status', alignRight: false },
//   { id: '' }
// ];

const rolesNotAllowed = ['plus', 'basic', 'lite', 'cajeros', 'cliente-corporativo'];
const getTableHeadColumns = (userRole) => {
  const baseColumns = [
    { id: 'name', label: 'Propietario', alignRight: false },
    { id: 'orden', label: 'Usuario asignado', alignRight: false },
    { id: 'created_at', label: 'Fecha', alignRight: false },
    { id: 'cantidad', label: 'Productos', alignRight: false },
    { id: 'totalAmount', label: 'Precio', alignRight: false },
    { id: 'costo', label: 'Costo', alignRight: false },
    { id: 'ulic', label: 'U. Licenciatario', alignRight: false },
    { id: 'status', label: 'Status', alignRight: false },
    { id: '' }
  ];

  if (!rolesNotAllowed.includes(userRole)) {
    baseColumns.splice(6, 0, { id: 'utilidad', label: 'U. Total', alignRight: false });
    baseColumns.splice(8, 0, { id: 'udag', label: 'U. Dagpacket', alignRight: false });
  }

  return baseColumns;
};
const CONTENT = [
  {
    id: '345',
    fecha: '2022-05-24T15:32:36.199Z',
    cantidad: 3,
    fechaEntrega: '2022-05-24T15:32:36.199Z',
    recibo: 'archivo'
  },
  {
    id: '365',
    fecha: '2022-05-24T15:32:36.199Z',
    cantidad: 3,
    fechaEntrega: '2022-05-24T15:32:36.199Z',
    recibo: 'archivo'
  },
  {
    id: '654',
    fecha: '2022-05-24T15:32:36.199Z',
    cantidad: 3,
    fechaEntrega: '2022-05-24T15:32:36.199Z',
    recibo: 'archivo'
  }
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  if (query) {
    return filter(array, (_product) => _product?.id?.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }

  return stabilizedThis.map((el) => el[0]);
}

function RegistroVentaEmpaques({ dataTable, userIds }) {
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [orderBy, setOrderBy] = useState('createdAt');
  const [usersList, setUsersList] = useState([]);
  const [desde, setDesde] = useState();
  const [hasta, setHasta] = useState();
  const { currentUser } = useAuthUsers();
  const navigate = useNavigate();
  const TABLE_HEAD = getTableHeadColumns(currentUser.role);

  useEffect(() => {
    async function getUsersList() {
      const usersDataRef = firestore.collection('users');
      const usersData = await usersDataRef.get();
      const usersDataList = usersData.docs.map((user) => ({ id: user.id, ...user.data() }));
      setUsersList(usersDataList);
    }

    getUsersList();
  }, []);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = CONTENT.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const handleDesde = (e) => {
    setDesde(e.target.value);
  };
  const handleHasta = (e) => {
    setHasta(e.target.value);
  };

  const newHasta = addOneDay(hasta);
  const filterDate = useCallback((dataArr, initialDate, finalDate, compareDatePropName) => {
    const filteredData = dataArr.filter((item) => {
      if (initialDate === '' && finalDate === '') {
        return item;
      }

      if (typeof item[compareDatePropName] === 'object') {
        if (
          item[compareDatePropName]?.toDate() >= (initialDate ? new Date(initialDate) : new Date('2017-05-24')) &&
          item[compareDatePropName]?.toDate() <= (finalDate ? new Date(finalDate) : new Date())
        ) {
          return item;
        }
      }
      return false;
    });

    return filteredData;
  }, []);

  const filteredProducts = applySortFilter(dataTable, getComparator(order, orderBy), filterName);

  const { filteredData, setSearchTerm, searchTerm } = useFilter(usersList);

  const filteredResults = filteredProducts.filter((item) =>
    filteredData.some((user) => user.id === item.hostUserId || user.id === item.userId)
  );
  const filteredByDate = filterDate(filteredResults, desde, newHasta, 'updated_at');

  const usersIdAndNamesList = usersList.map((user) => ({ id: user.id, displayName: user.displayName }));

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - filteredByDate.length) : 0;
  const isProductNotFound = filteredProducts.length === 0;
  return (
    <>
      {/* <DialogVentaProd /> */}
      <Card>
        <Box display="flex" justifyContent="center" sx={{ margin: '15px 0' }}>
          <Typography component="h2" variant="h4">
            Empaques
          </Typography>
        </Box>
        <Divider />
        <ProductListToolbar
          numSelected={selected.length}
          filterName={searchTerm}
          onFilterName={setSearchTerm}
          onDesdeDate={handleDesde}
          onHastaDate={handleHasta}
          hasFiltrador
          hasFilterDate
          hasReporte
          hasReporteExcel
          reporteData={filteredByDate}
          usersIdList={usersIdAndNamesList}
          userIds={userIds}
          intervaloReporte={{ date_from: desde, date_to: hasta }}
        />
        <Scrollbar>
          <TableContainer sx={{ minWidth: 800 }}>
            <Table>
              <ProductListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={dataTable.length}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
                onSelectAllClick={handleSelectAllClick}
                checkbox={false}
              />
              <TableBody>
                {/* {filteredResults.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => { */}
                {filteredByDate.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                  const { id, created_at, totalAmount, cantidad, status, userId, items, hostUserId, utlity } = row;

                  const usuarioPropietario = usersList.find((user) => user.id === hostUserId);
                  const usuarioAsignado = usersList.find((user) => user.id === userId);

                  const isItemSelected = selected.indexOf(id) !== -1;
                  const canSeeUtilities = !rolesNotAllowed.includes(currentUser.role);
                  const totalPriceCompra = items.reduce((accumulator, currentItem) => {
                    // eslint-disable-next-line no-prototype-builtins
                    if (accumulator === null || !currentItem.hasOwnProperty('priceCompraTotal')) {
                      return null;
                    }
                    return accumulator + currentItem.priceCompraTotal;
                  }, 0);

                  const displayPriceCompra = totalPriceCompra === null ? '-' : fCurrency(totalPriceCompra);
                  const totalUtility = items.reduce((accumulator, currentItem) => {
                    // eslint-disable-next-line no-prototype-builtins
                    if (accumulator === null || !currentItem.hasOwnProperty('utlity')) {
                      return null;
                    }
                    return accumulator + currentItem.utlity;
                  }, 0);

                  const displayUtility = totalUtility === null ? '-' : fCurrency(totalUtility);
                  const utilDagPacket = totalUtility === null ? '-' : fCurrency(totalUtility * 0.3);
                  const utilLic = totalUtility === null ? '-' : fCurrency(totalUtility * 0.7);

                  return (
                    <TableRow
                      hover
                      key={id}
                      tabIndex={-1}
                      role="checkbox"
                      selected={isItemSelected}
                      aria-checked={isItemSelected}
                    >
                      <TableCell style={{ minWidth: 160 }}>
                        {usuarioPropietario ? usuarioPropietario.displayName : 'Usuario desconocido'}
                      </TableCell>
                      <TableCell style={{ minWidth: 160 }}>
                        {usuarioAsignado ? usuarioAsignado.displayName : 'Usuario desconocido'}
                      </TableCell>
                      <TableCell style={{ minWidth: 160 }}>{fDateTime(created_at.toDate())}</TableCell>

                      <TableCell>{items ? <MenuButton data={items} /> : 'No hay Productos'}</TableCell>

                      <TableCell>{fCurrency(totalAmount)}</TableCell>
                      <TableCell>{displayPriceCompra}</TableCell>
                      {canSeeUtilities && <TableCell>{displayUtility}</TableCell>}
                      {/* <TableCell>-</TableCell> */}
                      {/* <TableCell>-</TableCell> */}
                      <TableCell>{utilLic}</TableCell>
                      {canSeeUtilities && <TableCell>{utilDagPacket}</TableCell>}

                      <TableCell>{status}</TableCell>
                      <TableCell>
                        <Button variant="contained" onClick={() => navigate(`/dashboard/paquetes/productos/${id}`)}>
                          Detalles
                        </Button>
                      </TableCell>
                    </TableRow>
                  );
                })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
              {isProductNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6}>
                      <Box sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </Scrollbar>

        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={filteredByDate.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
    </>
  );
}

export default RegistroVentaEmpaques;
